import { Component } from 'react';

import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { EnvironmentService } from '../../services/environment.service';
import MotiveFrame from '../motive-frames/motive-frame.component';
import styles from './faq.component.module.scss';

export default class FAQComponent extends Component {
    faqEnabled = true;

    @lazyInject(EnvironmentService) private envService: EnvironmentService;

    constructor(props) {
        super(props);
        this.faqEnabled = this.envService.isXConvert();
    }

    render() {
        if (!this.faqEnabled) {
            return null;
        }

        return <MotiveFrame>
            <div className={styles['wrapper']}>
                <div className={styles['main-card']}>
                    <div className={styles['header']}>
                        <h1 className={styles['title']}>Frequently Asked Questions</h1>
                        <p className={styles['description']}>
                            Find answers to common questions about using XConvert, file security, and output configurations.
                        </p>
                    </div>

                    <ol className={styles['faq']}>
                        <li>
                            <a href="/faq/how-can-i-convert-files-on-my-own-computer-without-uploading-them-to-your-site"> How can I
                                convert
                                files on my own computer without uploading them to your site?</a>
                        </li>
                        <li>
                            <a href="/faq/how-can-i-create-a-html-file-from-pdf-file"> How can I create a html file from PDF file?</a>
                        </li>
                        <li>
                            <a href="/faq/how-can-i-get-more-information-on-pdf-file-formats"> How can I get more information on PDF
                                file
                                formats?</a>
                        </li>
                        <li>
                            <a href="/faq/how-can-i-make-a-pdf-file"> How can I make a PDF file?</a>
                        </li>
                        <li>
                            <a href="/faq/how-can-i-purchase-the-xconvert.com-software"> How can I purchase the xconvert.com software?</a>
                        </li>
                        <li>
                            <a href="/faq/how-can-i-specify-the-paper-size"> How can I specify the paper size?</a>
                        </li>
                        <li>
                            <a href="/faq/how-do-i-get-color-output"> How do I get color output?</a>
                        </li>
                        <li>
                            <a href="/faq/how-do-i-make-a-postscript-compatible-file-without-a-postscript-compatible-printer"> How do
                                I make a postscript compatible file without a postscript compatible printer?
                            </a>
                        </li>
                        <li>
                            <a href="/faq/how-long-are-files-stored-on-the-server"> How long are files stored on the server?</a>
                        </li>
                        <li>
                            <a href="/faq/i-am-having-problems-installing-ghostscript"> I'm having problems installing Ghostscript</a>
                        </li>
                        <li>
                            <a
                                href="/faq/i-get-error-number-sign-x-when-converting-the-document-and-the-resulting-pdf-file-didn-not-open">
                                I get error #x when converting the document and the resulting PDF file didn't open?</a>
                        </li>
                        <li>
                            <a href="/faq/i-hit-convert-and-nothing-happens"> I hit convert and nothing happens?</a>
                        </li>
                        <li>
                            <a href="/faq/is-there-a-size-limit-to-the-converted-files"> Is there a size limit to the converted
                                files?</a>
                        </li>
                        <li>
                            <a href="/faq/when-i-view-the-pdf-file-it-doesn-not-look-like-my-original-document"> When I view the PDF
                                file
                                it doesn't look like my original document?</a>
                        </li>
                        <li>
                            <a href="/faq/where-are-the-converted-files-stored"> Where are the converted files stored?</a>
                        </li>
                        <li>
                            <a href="/faq/who-has-access-to-the-converted-files"> Who has access to the converted files?</a>
                        </li>
                    </ol>
                </div>
            </div>
        </MotiveFrame>
    }
}
